<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNum" />
		</section>
		<div class="basis-cls_table">
			<table-pagination ref="tableItem" pagination layout="prev,pager,next,total" :data="data" :column="column" v-loading="loading"
				:total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />
		</div>
		<editSetting ref="editSetting" @getList="getList"></editSetting>
		<!-- 应用到其他技能组 -->
		<applyGroup ref="applyGroup" :details="current_row" apiUrl="/livechat/chatSetting/copy/auth/"></applyGroup>
	</div>
</template>

<script>
	import editSetting from './editSetting'
	import applyGroup from '../common/applyGroup.vue'
	import { mapGetters } from "vuex";
	export default {
		components:{
			editSetting,
			applyGroup
		},
		computed:{
			 ...mapGetters([
				'subBrandList',
			])
		},
		data(){
			return {
				data:[],
				filterHeader: [
					{ label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{ label: '技能组', model: 'skillName', type: 'input', default: '', placeholder: '请输入技能组名称' },
				],
				listQuery: {
					brand:this.$store.state.user.brandId,
					childBrand: "",
					pageNum: 1,
					pageSize: 10,
					skillName:''
				},
				loading:false,
				total:0,
				current_row:'',
				column:[
					{ label: "技能组ID", prop: "skillId" },
					{ label: "技能组名称", prop: "skillName" },
					{ label: "品牌", prop: "childBrandName" },
					{
						label: "创建时间",
						prop: "createTime",
						width:200,
						sortable: true,
						render:(h,scope) => {
							return <span>{this.$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm")}</span>
						}
					},
					{
						label: "聊天权限设置",
						prop: "action",
						align: "center",
						width: 200,
						fixed:'right',
						render: (h, scope) => {
						return (
							<div class="operate-inline">
							<el-button type="text" size="small" onClick={() => this.onSetting(scope.row)}>
								配置
							</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="text" size="small" onClick={() => this.onApply(scope.row)}>
								应用到其他技能组
							</el-button>
							</div>
						);
						}
					}
				]
			}
		},
		methods:{
			filterSearch(query) {
				this.listQuery = Object.assign(this.listQuery, query);
				this.getList();
			},
			onSetting(row){
				this.$refs.editSetting.openSetting(row)
			},
			onApply(row){
				this.$refs.applyGroup.openApply();
				this.current_row = Object.assign({},row)
					
			},
			getList(val){
				if(val) {
					this.listQuery.pageNum = val.page
				}
				let params = {
					pageNum: this.listQuery.pageNum,
					pageSize: this.listQuery.pageSize,
					data: {
						brand: this.listQuery.brand,
						childBrand: this.listQuery.childBrand,
						skillName:this.listQuery.skillName,
					}
				}
				this.loading = true
				this.$api.postSystemChatList(params).then(res => {
					this.loading = false
					if(res.errcode == 0) {
						this.data = res.list
						this.total = res.total
					}
				})
			}
		},
		async mounted(){
			await this.getList()
			this.filterHeader[0]['list'] = await this.subBrandList;
		}
	}
</script>


